export function initScroll() {
    const sectionNames = {
        'services': 'Створюємо',
        'portfolio': 'Портфоліо',
        'technical-features': 'ТехСервіс',
        'advantages': 'Чому ми?',
        'platform-comparison': 'Порівняння',
        'common-mistakes': 'Часті помилки',
        'for-whom': 'Для кого ми',
        'diy-vs-us': 'Самому vs З нами',
        'pricing': 'Пакети',
        'promo': 'Акції',
        'briefs': 'Отримати',
        'mini-services': 'Міні-сервіс',
        'ai-prompting-dynamic': 'AI Сервіс',
        'extras': 'Додаткове',
        'certificate-gift': 'Сувенір',
        'testimonials': 'Відгуки',
        'faq': 'FAQ',
        'hosting-help': 'Розміщення',
        'blog': 'Дайджест',
        'international': 'International',
        'contact-gift-wrapper': 'Контакти',
        'guide-bonus': 'Бонус+',
        'social': 'Соцмережі',
        'security': 'Кібербезпека',
        'evolution': 'Новації та Еволюція'
    };

    const sections = document.querySelectorAll('section[id]');
    const currentSection = document.getElementById('current-section');
    const breadcrumbs = document.getElementById('breadcrumbs');
    const progressBar = document.getElementById('progressBar');

    if (!sections.length || !currentSection || !progressBar) return;

    window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;
        progressBar.style.width = scrollPercent + '%';

        let current = 'Головна';
        sections.forEach(section => {
            const sectionTop = section.offsetTop - 20;
            if (scrollTop >= sectionTop) current = section.getAttribute('id');
        });
        currentSection.textContent = sectionNames[current] || 'Головна';
    });

    window.addEventListener('DOMContentLoaded', () => {
        if (window.innerWidth <= 768 && breadcrumbs) {
            breadcrumbs.style.transition = 'top 0.25s ease';
            breadcrumbs.style.top = '1cm';
            setTimeout(() => breadcrumbs.style.top = '0.5cm', 6000);
        }
    });
}
